module.exports = __webpack_public_path__ + "static/media/move_in.896669b2.svg";